<script>
export default {
  name: "period-list",
  props: {
    periods: Array,
    type: String,
  },
  data() {
    return {
      requiredRule: [(v) => !!v || "Required"],
      allPeriodTypes: [
        { Key: "Firm", Value: "Firm" },
        { Key: "Firm Until", Value: "Firm Until" },
        { Key: "Day By Day", Value: "D/D" },
        { Key: "Day By Day as required", Value: "D/D As Req'd" },
        { Key: "Day By Day as required to latest redelivery", Value: "D/D to L/R" },
        { Key: "Well (Firm)", Value: "Well" },
        { Key: "Well (Optional)", Value: "Well (Optional)" },
        { Key: "Cargo Run (Firm)", Value: "C/R" },
        { Key: "Cargo Run (Optional)", Value: "C/R (Optional)" },
        { Key: "Optional", Value: "Optional" },
      ],
      durationTypes: ["Days", "Weeks", "Months", "Years"],
      thesePeriods: [],
      defaultPeriod: {
        PeriodType: "Day By Day",
        PeriodDurationCount: 14,
        PeriodDurationType: "Days",
        SortOrder: 0,
        Quantity: 1,
        Option: 1,
        Note: "",
        LatestRedeliveryDate: "",
        DailyRate: null,
        DailyRateCurrency: "",
        OnHireDate: null,
        OffHireDate: null,
        DateFixed: null,
        IsAlternateOption: false,
      },
      allCurrencies: [],
    };
  },
  methods: {
    getPeriodDescription(p) {
      var result = "";
      if (p.PeriodType == "Firm") {
        result = `Firm for ${p.PeriodDurationCount} ${p.PeriodDurationType}`;
      } else if (p.PeriodType == "Firm Until") {
        result = `Firm until ${formatDate(p.LatestRedeliveryDate)}`;
      } else if (p.PeriodType == "Day By Day") {
        result = `D/D ${p.PeriodDurationCount} `;
      } else if (p.PeriodType == "Day By Day as required") {
        result = `D/D As Req'd`;
      } else if (p.PeriodType == "Day By Day as required to latest redelivery") {
        result = `D/D As Req'd to ${p.LatestRedeliveryDate ? formatDate(p.LatestRedeliveryDate) : "xx/xx/xx"} L/R`;
      } else if (p.PeriodType == "Well (Firm)") {
        result = `${p.Quantity} x ${p.Quantity > 1 ? "Wells" : "Well"}`;
      } else if (p.PeriodType == "Well (Optional)") {
        result = `${p.Quantity} x ${p.Quantity > 1 ? "Wells (Optional)" : "Well (Optional)"}`;
      } else if (p.PeriodType == "Cargo Run (Firm)") {
        result = `${p.Quantity} x C/R`;
      } else if (p.PeriodType == "Cargo Run (Optional)") {
        result = `${p.Quantity} x C/R (Optional)`;
      } else if (p.PeriodType == "Optional") {
        result = `${p.Quantity} x ${p.PeriodDurationCount} ${p.PeriodDurationType} Optional`;
      }
      result = `<b>${result}</b>`;
      if (this.type == "offer" && p.DailyRateCurrency && p.DailyRate) {
        result += ` @ <span class='green--text'>${this.getFormatedRate(p.DailyRateCurrency, p.DailyRate)}</span>`;
      }
      return result;
    },
    getFormatedRate(currency, rate) {
      if (currency == "NOK" || currency == "DKK" || currency == "CAD") {
        return `${currencyFormatted(rate)} ${currency}`;
      } else {
        return `${this.getCurrencySymbol(currency)}${currencyFormatted(rate)}`;
      }
    },
    getCurrencySymbol(currency) {
      if (this.allCurrencies && currency) {
        return this.allCurrencies.filter(function(x) {
          return x.Key == currency;
        })[0].Value;
      }
    },
    onAddPeriod() {
      var toAdd = JSON.parse(JSON.stringify(this.defaultPeriod));
      this.thesePeriods.push(toAdd);
    },
    deletePeriod(index) {
      this.thesePeriods = this.thesePeriods.splice(index, 1);
    },
    async getAllCurrencies() {
      this.allCurrencies = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetCurrencyTypesShort` });
    },
  },
  computed: {
    periodSummary() {
      var self = this;
      if (this.thesePeriods) {
        var result = this.thesePeriods.map(function(x) {
          return self.getPeriodDescription(x);
        });
        return `<i>${result.join(" + ")}</i>`;
      }
    },
  },
  mounted() {
    this.getAllCurrencies();
    this.thesePeriods = this.periods ? this.periods : [];
  },
  watch: {
    periods: {
      deep: true,
      handler(val) {
        this.thesePeriods = val;
      },
    },
    thesePeriods: {
      deep: true,
      handler(val) {
        if (JSON.stringify(val) != JSON.stringify(this.periods)) {
          this.$emit("updatePeriod", val);
        }
      },
    },
  },
};
</script>
<template>
  <v-row v-if="type == 'requirement'">
    <v-col cols="12">
      <span class="text--h5" v-html="periodSummary"></span>
    </v-col>
    <v-col v-for="(p, index) in thesePeriods" :key="`${index}-period`" cols="12" class="py-0">
      <v-row v-if="p.PeriodType == 'Day By Day' || p.PeriodType == 'Firm'">
        <v-col cols="4">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field dense :rules="requiredRule" hide-details="auto" type="number" v-model.number="p.PeriodDurationCount" outlined :label="`No. of ${p.PeriodDurationType}`"></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-select :disabled="p.PeriodType == 'Day By Day'" dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodDurationType" :items="durationTypes" outlined label="Duration Type"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-select
          >
        </v-col>
      </v-row>
      <v-row v-else-if="p.PeriodType == 'Optional'">
        <v-col cols="3">
          <v-text-field dense :rules="requiredRule" hide-details="auto" v-model.number="p.Quantity" outlined label="Quantity"></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="3">
          <v-text-field dense :rules="requiredRule" hide-details="auto" type="number" v-model.number="p.PeriodDurationCount" outlined :label="`No. of ${p.PeriodDurationType}`"></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-select :disabled="p.PeriodType == 'Day By Day'" dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodDurationType" :items="durationTypes" outlined label="Duration Type"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-select
          >
        </v-col>
      </v-row>
      <v-row v-else-if="p.PeriodType == 'Day By Day as required'">
        <v-col cols="12">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"
            ><template slot="append-outer"> <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template></v-select
          >
        </v-col>
      </v-row>
      <v-row v-else-if="p.PeriodType == 'Firm Until' || p.PeriodType == 'Day By Day as required to latest redelivery'">
        <v-col cols="6">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="6">
          <v-text-field dense :rules="requiredRule" hide-details="auto" type="datetime-local" v-model="p.LatestRedeliveryDate" outlined label="Redelivery"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-text-field
          >
        </v-col>
      </v-row>
      <v-row v-else-if="p.PeriodType == 'Well (Firm)' || p.PeriodType == 'Well (Optional)' || p.PeriodType == 'Cargo Run (Firm)' || p.PeriodType == 'Cargo Run (Optional)'">
        <v-col cols="6">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="6">
          <v-text-field dense :rules="requiredRule" hide-details="auto" type="number" v-model.number="p.Quantity" outlined label="Quantity"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-text-field
          >
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12"
      ><v-btn @click="onAddPeriod" block>Add Period <v-icon class="ml-2">mdi-plus-circle</v-icon></v-btn></v-col
    >
  </v-row>
  <v-row v-else-if="type == 'offer'">
    <v-col cols="12">
      <span class="text--h5" v-html="periodSummary"></span>
    </v-col>
    <v-col v-for="(p, index) in thesePeriods" :key="`${index}-period`" cols="12" class="py-0">
      <v-row v-if="p.PeriodType == 'Day By Day' || p.PeriodType == 'Firm'">
        <v-col cols="3">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="2">
          <v-text-field dense :rules="requiredRule" hide-details="auto" type="number" v-model.number="p.PeriodDurationCount" outlined :label="`No. of ${p.PeriodDurationType}`"></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-select
            :disabled="p.PeriodType == 'Day By Day'"
            dense
            :rules="requiredRule"
            hide-details="auto"
            v-model="p.PeriodDurationType"
            :items="durationTypes"
            outlined
            label="Duration Type"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.DailyRateCurrency" :items="allCurrencies" item-text="Value" item-value="Key" outlined label="Currency"></v-select>
        </v-col>
        <v-col cols="2">
          <v-text-field dense :rules="requiredRule" hide-details="auto" v-model.number="p.DailyRate" type="number" outlined label="Rate"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-text-field
          >
        </v-col>
      </v-row>
      <v-row v-else-if="p.PeriodType == 'Optional'">
        <v-col cols="2">
          <v-text-field dense :rules="requiredRule" hide-details="auto" v-model.number="p.Quantity" outlined label="Qty"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="2">
          <v-text-field dense :rules="requiredRule" hide-details="auto" type="number" v-model.number="p.PeriodDurationCount" outlined :label="`No. of ${p.PeriodDurationType}`"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-select
            :disabled="p.PeriodType == 'Day By Day'"
            dense
            :rules="requiredRule"
            hide-details="auto"
            v-model="p.PeriodDurationType"
            :items="durationTypes"
            outlined
            label="Duration Type"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.DailyRateCurrency" :items="allCurrencies" item-text="Value" item-value="Key" outlined label="Currency"></v-select>
        </v-col>
        <v-col cols="2">
          <v-text-field dense :rules="requiredRule" hide-details="auto" v-model.number="p.DailyRate" type="number" outlined label="Rate"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-text-field
          >
        </v-col>
      </v-row>
      <v-row v-else-if="p.PeriodType == 'Day By Day as required'">
        <v-col cols="4">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="4">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.DailyRateCurrency" :items="allCurrencies" item-text="Value" item-value="Key" outlined label="Currency"></v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field dense :rules="requiredRule" hide-details="auto" v-model.number="p.DailyRate" type="number" outlined label="Rate"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-text-field
          >
        </v-col>
      </v-row>
      <v-row v-else-if="p.PeriodType == 'Firm Until' || p.PeriodType == 'Day By Day as required to latest redelivery'">
        <v-col cols="3">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field dense :rules="requiredRule" hide-details="auto" type="datetime-local" v-model="p.LatestRedeliveryDate" outlined label="Redelivery"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.DailyRateCurrency" :items="allCurrencies" item-text="Value" item-value="Key" outlined label="Currency"></v-select>
        </v-col>
        <v-col cols="3">
          <v-text-field dense :rules="requiredRule" hide-details="auto" v-model.number="p.DailyRate" type="number" outlined label="Rate"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-text-field
          >
        </v-col>
      </v-row>
      <v-row v-else-if="p.PeriodType == 'Well (Firm)' || p.PeriodType == 'Well (Optional)' || p.PeriodType == 'Cargo Run (Firm)' || p.PeriodType == 'Cargo Run (Optional)'">
        <v-col cols="3">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.PeriodType" :items="allPeriodTypes" item-text="Value" item-value="Key" outlined label="Type"></v-select>
        </v-col>
        <v-col cols="3">
          <v-text-field dense :rules="requiredRule" hide-details="auto" type="number" v-model.number="p.Quantity" outlined label="Quantity"></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-select dense :rules="requiredRule" hide-details="auto" v-model="p.DailyRateCurrency" :items="allCurrencies" item-text="Value" item-value="Key" outlined label="Currency"></v-select>
        </v-col>
        <v-col cols="3">
          <v-text-field dense :rules="requiredRule" hide-details="auto" v-model.number="p.DailyRate" type="number" outlined label="Rate"
            ><template v-if="thesePeriods.length > 1" slot="append-outer">
              <v-icon style="pointer-events: auto;" @click="deletePeriod(index)" title="Delete this period">mdi-delete-circle</v-icon></template
            ></v-text-field
          >
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12"
      ><v-btn @click="onAddPeriod" block>Add Period <v-icon class="ml-2">mdi-plus-circle</v-icon></v-btn></v-col
    >
  </v-row>
</template>
<style scoped></style>
